import { useSelector } from '@xstate/store/react';
import { canvasSelectionStore } from '../stores/canvasSelectionStore';

export function useSelectionCount(): number {
  return useSelector(canvasSelectionStore, s => s.context.selectedEntityIds.length);
}
